
















































import Vue from 'vue'
import { getCountries } from '~/api/Address/address'
import { carClientsController } from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import PhoneTextField from '~/components/PhoneTextField.vue'
import { TableHeader } from '~/utils/interfaces'
import { CarClient, CreateCarClient } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { AppView, PhoneTextField, Autocomplete },
  data() {
    return {
      controller: carClientsController,
      headers: [
        {
          text: this.$t('first_name'),
          value: 'first_name',
        },
        {
          text: this.$t('last_name'),
          value: 'last_name',
        },
        {
          text: this.$t('email'),
          value: 'email',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: this.$t('passport'),
          value: 'identity',
        },
        {
          text: this.$t('nationality'),
          value: 'nationality_name',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarClient>[],
      defaultCrud: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        identity: '',
        nationality: 0,
      } as CreateCarClient,
    }
  },
  methods: {
    getCountries,
  },
})
